import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { ViewWeekOutlined as ViewWeek } from '@mui/icons-material';
import { NodeWrapper } from "./NodeWrapper";
import { i18n } from "../../../translate/i18n";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW, mkHandleStyle, mkInputHandleStyle, mkOutputHandleStyle } from "./nodeStyles";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));


export default memo(({ data, isConnectable, id, selected }) => {
  const classes = useStyles();
  return (
    <NodeWrapper id={id} selected={selected} color="#FF5A00">
      <Handle 
        type="target" 
        position="left" 
        style={mkInputHandleStyle("#FF5A00")} 
        isConnectable={isConnectable} 
      />
      <Handle 
        type="source" 
        position="right" 
        id="a" 
        style={mkOutputHandleStyle("#FF5A00")} 
        isConnectable={isConnectable} 
      />
      <div style={mkHeaderStyle("#FF5A00")}>
        <ViewWeek style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>{data?.name || i18n.t("flowBuilder.kanban.name")}</div>
      
        <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#fb923c' }}>
                💡 {i18n.t("flowBuilder.tooltips.kanban.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.kanban.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </IconButton>
        </HtmlTooltip>
      </div>
      <div style={NODE_BODY_STYLE}>
        <div style={{ ...NODE_INFO_ROW, marginBottom: "8px" }}>
          {data?.selectedBoard?.name || i18n.t("flowBuilder.kanban.noBoard")}
        </div>
        <div style={{ ...NODE_INFO_ROW, marginBottom: Array.isArray(data?.laneTags) && data.laneTags.length > 0 ? "8px" : "0px", position: "relative" }}>
          {data?.selectedLane?.name || i18n.t("flowBuilder.kanban.noLane")}
        </div>
        {Array.isArray(data?.laneTags) && data.laneTags.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {data.laneTags.map((tag) => (
              <span
                key={tag.id}
                style={{
                  backgroundColor: tag.color ? `${tag.color}22` : "#e2e8f0",
                  color: tag.color || "#334155",
                  border: `1px solid ${tag.color || "#cbd5e1"}`,
                  borderRadius: "12px",
                  padding: "2px 8px",
                  fontSize: "11px",
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: tag.color || "#334155",
                    marginRight: "5px",
                    flexShrink: 0,
                  }}
                />
                {tag.name}
              </span>
            ))}
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});
